<template>
  <div class="frisbuy-question">
    <div class="frisbuy-question__header">
      {{ interaction.caption }}
    </div>

    <div class="frisbuy-question__body">
      <input
        type="text"
        class="frisbuy-question__body-input"
        :placeholder="interaction.placeholder"
        @click="() => selectInputHandler(true)"
        @blur="() => selectInputHandler(false)"
        v-model="answer"
        maxlength="80"
      />
    </div>

    <button
      v-if="answer || isAnswered || isShowAlwaysSendButton"
      class="frisbuy-question__send-button"
      :class="{
        'frisbuy-question__send-button--complete': isAnswered,
        'frisbuy-question__send-button--waiting': isAnswered && !isQuerySuccess,
      }"
      @click="() => handleSend()"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    interaction: {
      type: Object,
      require: true,
    },

    isQuerySuccess: {
      type: Boolean,
      require: false,
      default: true,
    },

    isShowAlwaysSendButton: {
      type: Boolean,
      require: false,
      default: false,
    },
  },

  emits: ["getAnswer", "selectInput", "unSelectInput"],

  data() {
    return {
      answer: "",
      isAnswered: false,
    };
  },

  computed: {
    buttonText() {
      if (this.isAnswered) {
        if (this.isQuerySuccess) {
          return "Ответ отправлен";
        }

        return "Отправка...";
      }
      return "Отправить";
    },
  },

  methods: {
    selectInputHandler(isSelected) {
      if (isSelected) {
        this.isAnswered = false;
        this.$emit("selectInput");
      } else {
        this.$emit("unSelectInput");
      }
    },

    handleSend() {
      if (this.answer.length === 0) {
        return;
      }

      this.isAnswered = true;

      this.$emit("getAnswer", { answer: this.answer, ...this.interaction });
    },
  },

  watch: {
    answer(value) {
      if (value.length > 0) {
        this.isAnswered = false;
      }
    },

    isQuerySuccess(isSuccess) {
      if (isSuccess) {
        this.answer = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

$color-button-main: #0495ff;
$color-button-complete: #00cc35;

.frisbuy-question {
  display: inline-block;
  background-color: #fff;
  border-radius: 10px 10px 12px 12px;
  font-family: Roboto;
  width: calc(var(--frisbuy-interaction-width) * 235 * 1px);

  cursor: default;

  .frisbuy-question__header {
    text-align: center;
    font-size: calc(var(--frisbuy-interaction-width) * 18 * 1px);
    font-family: "Roboto Condensed";
    padding: calc(var(--frisbuy-interaction-width) * 16 * 1px)
      calc(var(--frisbuy-interaction-width) * 12 * 1px) 0;
  }

  .frisbuy-question__body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: calc(var(--frisbuy-interaction-width) * 12 * 1px);

    .frisbuy-question__body-input {
      color: #000;
      font-size: calc(var(--frisbuy-interaction-width) * 14 * 1px);
      font-family: "Roboto", sans-serif;
      background-color: #d9d9d9;

      border: 0;
      border-radius: 10px;

      outline: none;

      padding: calc(var(--frisbuy-interaction-width) * 14 * 1px)
        calc(var(--frisbuy-interaction-width) * 12 * 1px);

      ::placeholder {
        color: #616f77;
      }
    }
  }

  .frisbuy-question__send-button {
    width: 100%;
    border: 0;
    display: block;
    border-radius: 0 0 10px 10px;
    padding: calc(var(--frisbuy-interaction-width) * 16 * 1px)
      calc(var(--frisbuy-interaction-width) * 12 * 1px);
    font-size: calc(var(--frisbuy-interaction-width) * 16 * 1px);
    font-family: "Roboto";
    background-color: $color-button-main;
    color: #fff;
    text-align: center;
    cursor: pointer;

    &--complete {
      background-color: $color-button-complete;
      cursor: not-allowed;
    }

    &--waiting {
      background: linear-gradient(
        115deg,
        $color-button-main,
        $color-button-main,
        $color-button-main,
        $color-button-main,
        aliceblue,
        $color-button-main,
        $color-button-main,
        $color-button-main,
        $color-button-main
      );
      background-size: 400%;
      animation: gradient-animation 0.75s linear infinite;
      background-repeat: no-repeat;

      @keyframes gradient-animation {
        0% {
          background-position: 100% 0;
        }
        100% {
          background-position: 0 0;
        }
      }
    }
  }
}
</style>
